import http from "../http-common";

class AccordionService {
  getAccordionService(path: string) {
    return http.get(`/accordion?path=${path}`);
  }
}

export default new AccordionService();
